<template>
    <router-view></router-view>
</template>

<script>
import axios from 'axios/index';
import { mapState, mapActions } from 'vuex';

export default {
    name: 'app',
    async created() {
        this.updateRequestHeader();
        axios.interceptors.response.use(
            response => {
                return response;
            },
            error => {
                const status = error?.response?.status;
                const message = error?.response?.data?.message ?? 'error';
                if (status === 403) {
                    this.getCurrentUserDetail();
                    this.$router.push('/home');
                } else if (status === 401) {
                    this.actionLogout().then(() => {
                        this.$router.push('/home');
                    });
                } else {
                    this.$toaster.error(this.$t(message));
                }
                return Promise.reject(error?.response);
            }
        );
    },
    computed: {
        ...mapState({
            currentUser: state => state.auth.currentUser
        })
    },
    watch: {
        currentUser() {
            this.updateRequestHeader();
        }
    },
    methods: {
        ...mapActions({
            showLoading: 'page/showLoading',
            hideLoading: 'page/hideLoading',
            getCurrentUserDetail: 'auth/getCurrentUserDetail',
            actionLogout: 'auth/actionLogout'
        }),
        updateRequestHeader() {
            axios.interceptors.request.use(
                config => {
                    if (this.currentUser) {
                        config.headers.Authorization = `Bearer ${this.currentUser.token}`;
                    }
                    return config;
                },
                function (err) {
                    return Promise.reject(err);
                }
            );
        }
    }
};
</script>

<style lang="scss">
@import '@/scss/style';
</style>
